<template>
  <div>
    <v-dialog v-model="value" width="640" persistent fullscreen>
      <v-card height="100%" color="black" @click="loadCamera">
        <vue-record-video
          v-if="value == true"
          ref="record"
          @result="onResult"
          style="display: none"
          :audio="false"
        />
        <!-- <vue-web-cam
          v-if="value == true"
          ref="wc"
          :deviceId="firstDeviceId"
          style="height: 480px; width: 640px; position: absolute"
          width="640"
          @cameras="devices = $event"
        ></vue-web-cam> -->
        <!-- :selectFirstDevice="true" -->
        <videoCam
          v-if="value == true"
          :style="`position: absolute;width:${width};height:${height}`"
          :deviceId="deviceId"
        />
        <div style="position: relative; top: 1%; left: 2%; width: 300px">
          <v-layout>
            <v-btn icon dark @click="$emit('input', false)">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <v-select
              :items="devices"
              label="Cam"
              dark
              item-text="label"
              item-value="deviceId"
              style="ml-10"
              v-model="deviceId"
              class="ml-10"
            >
            </v-select>
          </v-layout>
        </div>

        <v-btn
          style="position: relative; top: 50%; left: 50%; opacity: 0.5"
          fab
          dark
          :color="record ? 'red' : 'white'"
          @click="recordVideo"
        >
          <div>
            <v-icon :color="record ? 'white' : 'red'">
              {{ record ? "mdi-stop" : "mdi-record" }}</v-icon
            >
          </div>
          <div>
            <vue-countdown-timer
              v-if="record"
              :start-time="startTime"
              :end-time="endTime"
              :interval="1000"
              style="color: white"
              @end_callback="endCountDown"
            >
              <template slot="countdown" slot-scope="scope">
                {{ scope.props.seconds }}
              </template>
            </vue-countdown-timer>
          </div>
        </v-btn>

        <!-- :selectFirstDevice="true" -->
        <!-- <div class="row pl-10 pr-10 pb-2">
          <v-btn color="primary" fab x-large dark @click="$emit('input',false)">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <v-spacer />
          <v-btn color="success" fab x-large dark @click="snapShot">
            <v-icon>mdi-camera</v-icon>
          </v-btn>
        </div>-->
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { isArray } from "xstate/lib/utils";
import videoCam from "../cams/videoCam";

export default {
  name: "cam-record-dialog",
  components: { videoCam },
  props: ["value"],
  data() {
    return {
      cameras: [],
      devices: [],
      record: false,
      firstDeviceId: null,
      startTime: null,
      endTime: null,
      seconds: 60,
      deviceId: null,
      width: null,
      height: null,
    };
  },
  watch: {
    deviceId(v) {
      if (!v) return;
      let record = this.$refs.record;
      if (!record) return;
       record.constraints.video = { deviceId: null };
       record.constraints.video.deviceId = v;
    },
    async devices(v) {
      if (v && v.length > 0) {
       // this.deviceId = v[0].deviceId;
        this.$forceUpdate();
        //await this.loadCamera();
      }
    },
    value() {
      if (this.value == true) {
        this.$nextTick(() => {
          //this.loadCamera();
        });
      }
    },
  },
  methods: {
    onResult(data) {
      this.$emit("result", data);
    },
    async endCountDown() {
      await this.recordVideo();
    },
    async recordVideo() {
      try {
        this.record = !this.record;
        let recordRef = this.$refs.record;
        if (this.record == true) {
          let now = new Date();
          this.startTime = new Date(now.toISOString());
          this.endTime = new Date(
            now.setSeconds(now.getSeconds() + this.seconds)
          );
          await recordRef.startRecording();
        } else {
          await recordRef.stop();
          this.startTime = null;
          this.endTime = null;
        }
      } catch (err) {
        alert(err.message);
      }
    },
    loadCamera() {
      //this.$refs.wc.loadCamera(this.firstDeviceId);
    },
    async getDevices() {
      return await navigator.mediaDevices
        .enumerateDevices()
        .then((deviceInfos) => {
          return deviceInfos.filter((di) => di.kind == "videoinput");
        });
    },
    later(delay) {
      return new Promise(function (resolve) {
        setTimeout(resolve, delay);
      });
    },
    async getFirstDeviceId() {
      let devices = await this.getDevices();
      if (isArray(devices)) return devices[0].deviceId;
      else return devices.deviceId;
    },
    async snapShot() {
      //   let file = await this.urltoFile(this.$refs.wc.capture(), "photo.jpg", "image/jpeg");
      //   this.$emit("snapshot", file);
      //   this.$emit("input", false);
    },
    async getPermissionCamera() {
      let permission = await navigator.permissions.query({ name: "camera" });
      if (permission.state == "granted") return;
      await navigator.mediaDevices.getUserMedia({ audio: false, video: true });
    },
    urltoFile(url, filename, mimeType) {
      return fetch(url)
        .then(function (res) {
          return res.arrayBuffer();
        })
        .then(function (buf) {
          return new File([buf], filename, { type: mimeType });
        });
    },
  },

  async destroyed() {
    navigator.mediaDevices
      .getUserMedia({ video: true, audio: false })
      .then((mediaStream) => {
        const stream = mediaStream;
        const tracks = stream.getTracks();

        tracks.forEach((t) => t.stop);
      });
  },
  async mounted() {
    await this.getPermissionCamera();

    this.$nextTick(() => {
      this.width = window.innerWidth;
      this.height = window.innerHeight;
    });

    //await chrome.permissions.request(["camera"]);
    this.devices = await this.getDevices();
    //this.firstDeviceId = await this.getFirstDeviceId();
  },
};
</script>
